import { render, staticRenderFns } from "./YcCheckbox.vue?vue&type=template&id=644b21a0&scoped=true&lang=pug&"
import script from "./YcCheckbox.vue?vue&type=script&lang=js&"
export * from "./YcCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./YcCheckbox.vue?vue&type=style&index=0&id=644b21a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644b21a0",
  null
  
)

export default component.exports